export default class MoreTabsController {
  constructor(ngDialog, Attachments, FileSaver, Blob) {
    "ngInject";
    this.ngDialog = ngDialog;
    this.Attachments = Attachments;
    this.FileSaver = FileSaver;
    this.Blob = Blob;
  }

  uploadFile() {
    const uploadModalPromise = this.ngDialog.openConfirm({
      template: "<upload-attachment class='upload-attachment' close-modal='closeThisDialog()' confirm='confirm(result)'></upload-attachment>",
      plain: true,
      bindToController: true,
      width: 400,
      disableAnimation: false,
    });

    uploadModalPromise.then((result) => {
      result.item_id = this.task.id;
      this.createAttachment(result)
    });
  }

  createAttachment(attachment){
    this.task.attachments.unshift(attachment);
    this.Attachments.create(attachment, this.task.id)
      .then((attachment) => {
        this.task.attachments[0] = attachment;
      })
      .catch(() => this.task.attachments.shift());
  }

  destroyAttachment(attachment) {
    const attachmentIndex = this.task.attachments.indexOf(attachment);
    this.task.attachments.splice(attachmentIndex, 1);
    this.Attachments.destroy(attachment.id, this.task.id)
      .catch(() => this.task.attachments.splice(attachmentIndex, 0, attachment));
  }

  downloadAttachment(attachment) {
    this.Attachments.download(attachment.id);
  }
}

// TODO check task authorization read policies



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/screens/task-detail-info/components/more-tabs/more-tabs.controller.js